import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { Article } from './article'

@Injectable({
  providedIn: 'root'
})

export class ArticleService {
  constructor(private http: HttpClient) { }
  get() {
    return this.http.get('/backend/api/articles')
  }
  getOne(Id: Number) {
    return this.http.get(`/backend/api/articles/${Id}`)
  }
  put(article: Article) {
    return this.http.put('/backend/api/articles', article)
  }
}
